<template>
  <div>
    <v-data-table
      dark
      :headers="headers"
      :items="items"
      :search="search"
      :single-expand="settings.singleExpand"
      :expanded.sync="settings.expanded"
      @update:expanded="expId(settings.expanded[0])"
      item-key="id"
      :show-expand="expandedRows"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ tableName }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          :disabled="methodsEnabled == false"
          small
          dark
          @click="metaId(item.id)"
          class="btn-table ml-2"
        >
          Update metafields
        </v-btn>
        <v-btn
          :disabled="methodsEnabled == false"
          class="btn-table ml-2"
          small
          dark
          @click="syncId(item.id)"
        >
          Synchronise reviews
        </v-btn>
        <v-btn
          :href="shopDomain + '/products/' + item.slug"
          target="_blank"
          :disabled="methodsEnabled == false"
          class="btn-table ml-2"
          small
          dark
        >
          View Product
        </v-btn>
        <v-btn
          :disabled="methodsEnabled == false"
          class="btn-table ml-2"
          small
          dark
          @click="undeleteReviews(item.id)"
        >
          Undelete reviews
        </v-btn>
        <v-btn
          :disabled="methodsEnabled == false"
          class="btn-table ml-2"
          small
          dark
          @click="publishReviews(item.id)"
        >
          Publish all reviews
        </v-btn>
        <v-btn
          :disabled="methodsEnabled == false"
          class="btn-table ml-2"
          small
          dark
          @click="removeDuplicatedReviews(item.id)"
        >
          Remove Duplicated Reviews
        </v-btn>
      </template>

      <template v-slot:[`item.trialDaysLeft`]="{ item }">
        {{ trialDaysLeftHandler(item.trialEndDate) }}
      </template>

      <template v-slot:[`item.sendReviewRequests`]="{ item }">
        <span v-if="item.sendReviewRequests">Active</span>
        <span v-else>Off</span>
      </template>

      <template v-slot:[`item.influencedRevenue`]="{ item }">
        {{ item.influencedRevenue[0].currency }}
        {{ item.influencedRevenue[0].amount }}
      </template>

      <template v-slot:[`item.totalOrders`]="{ item }">
        {{ item.influencedOrders }} / {{ item.totalOrders }}
      </template>

      <template v-slot:[`item.shopifyPlan`]="{ item }">
        <div class="text-capitalize">
          {{ item.shopifyPlan }}
        </div>
      </template>

      <template v-slot:[`item.activePlan`]="{ item }">
        <div class="text-capitalize">
          {{ item.activePlan }}
        </div>
      </template>

      <template v-slot:[`item.subscriptionDate`]="{ item }">
        <div class="text-capitalize">
          {{ dateFormated(item.subscriptionDate) }}
        </div>
      </template>

      <template v-slot:[`item.planPrice`]="{ item }">
        ${{ item.planPrice }}
      </template>

      <template v-slot:[`item.lifetimeSpend`]="{ item }">
        ${{ lifetimeSpendHandler(item.createdAt, item.planPrice) }}
      </template>

      <template v-slot:[`item.shopCreatedAt`]="{ item }">
        {{ dateFormated(item.shopCreatedAt) }}
      </template>

      <template v-slot:[`item.integrations`]="{ item }">
        <p v-if="item.integrationGorgiasActive">
          Gorgias
        </p>
        <p v-if="item.integrationKlaviyoActive">
          Klaviyo
        </p>
        <p v-if="item.integrationLimespotActive">
          Limespot
        </p>
        <p v-if="item.integrationLoyaltylionActive">
          Loyaltylion
        </p>
        <p v-if="item.integrationZendeskActive">
          Zendesk
        </p>
        <p v-if="item.integrationWiserActive">
          Wiser
        </p>
        <p v-if="item.integrationOmnisendActive">
          Omnisend
        </p>
      </template>

      <template v-slot:expanded-item="{}">
        <td :colspan="headers.length" v-if="importItems">
          <v-data-table
            :headers="importHeaders"
            :items="importItems"
            :search="importSearch"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Product import entries</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="importSearch"
                  append-icon="mdi-magnify"
                  label=""
                  single-line
                  hide-details
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn small dark @click="importId(item.id)">
                Synchronise product entry
              </v-btn>
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'DashboardTable',
  props: {
    shopDomain: {
      default: '',
      type: String,
    },
    // eslint-disable-next-line vue/require-default-prop
    importItems: {
      type: Array,
    },
    headers: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    settings: {
      required: true,
      type: Object,
    },
    methodsEnabled: {
      type: Boolean,
    },
    expandedRows: {
      type: Boolean,
    },
    tableName: {
      type: String,
      default: '',
    },
  },
  filters: {
    truncate: function(text, length, suffix) {
      return text.substring(0, length) + suffix;
    },
  },
  data() {
    return {
      importSearch: '',
      search: '',
      importSettings: {
        importSearch: '',
      },
      importHeaders: [
        { text: 'Id', value: 'id', width: '4%' },
        { text: 'Created at', value: 'createdTs', width: '32%' },
        { text: 'Import Source', value: 'importSource', width: '32%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '32%' },
      ],
    };
  },
  methods: {
    dateFormated(date) {
      if (date) {
        const dateParsed = new Date(date);

        return `${dateParsed
          .toLocaleString('en-GB', { timeZone: 'UTC' })
          .substring(0, 30)}`;
      } else {
        return '';
      }
    },
    trialDaysLeftHandler(date) {
      if (date) {
        const dateParsed = new Date(date);
        const today = new Date();
        const diffTime = today.getTime() - dateParsed.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

        return diffDays > 0 ? 0 : diffDays;
      } else {
        return '';
      }
    },
    lifetimeSpendHandler(dateCreation, price) {
      if (dateCreation) {
        const dateParsed = new Date(dateCreation);
        const today = new Date();

        const diffTimconste = today.getTime() - dateParsed.getTime();
        const diffDays = Math.floor(diffTimconste / (1000 * 3600 * 24));

        return Math.round(diffDays / 30) * price;
      } else {
        return '';
      }
    },
    metaId(number) {
      this.$emit('metaClicked', number);
    },
    syncId(number) {
      this.$emit('syncClicked', number);
    },
    undeleteReviews(number) {
      this.$emit('undeleteReviewsClicked', number);
    },
    publishReviews(number) {
      this.$emit('publishReviewsClicked', number);
    },
    importId(number) {
      this.$emit('importClicked', number);
    },
    expId(number) {
      if (number) {
        this.$emit('expClicked', number.id);
      }
    },
    removeDuplicatedReviews(number) {
      this.$emit('removeDuplicatedReviewsClicked', number);
    },
  },
};
</script>

<style scoped>
.btn-table {
  background-color: #0d1024 !important;
}
</style>
